import type { Catalog } from '../types';

// Cross-component chrome shared by several steps — translators translate these
// once. Component-scoped keys live in their own namespace files.
export const common: Catalog = {
  'common.back': 'Back',
  'common.securedByStripe': 'Secured by Stripe',
};
